import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

const Cell = styled.td`
  border: 1px solid ${({ theme }) => theme.color.border.secondary};
  border-top: none;
  padding: ${Spacing[3]};
  width: 50%;
  vertical-align: top;
`;

export default Cell;
